// extracted by mini-css-extract-plugin
export default {"button":"SpeakButton_button__K5uWb","icon":"SpeakButton_icon__R96-y"};